var React = require('react');

function SpinnerInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10,0v4 M10,16v4 M2.9,2.9l2.8,2.8 M14.2,14.2l2.8,2.8 M0,10h4 M16,10h4 M2.9,17.1l2.8-2.8 M14.2,5.8l2.8-2.8"}));
}

SpinnerInline.defaultProps = {"viewBox":"0 0 20 20","className":"stroke spinner"};

module.exports = SpinnerInline;

SpinnerInline.default = SpinnerInline;
